import { __rest } from "tslib";
import { useContext } from 'react';
import { StateContext } from '../state/stateContext';
/**
 * Hook that gets the actions for manipulating the global state.
 */
export function useActions() {
    const _a = useContext(StateContext), { state } = _a, actions = __rest(_a, ["state"]);
    return actions;
}
//# sourceMappingURL=actions.js.map